<script setup>
import { useToggle } from '@vueuse/core';
import { vOnClickOutside } from '@vueuse/components';
import { provideDropdownContext } from './provider.js';

defineProps({
  // Opens the dropdown body above the trigger instead of below it
  openTop: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close']);
const [isOpen, toggle] = useToggle(false);

const closeMenu = () => {
  if (isOpen.value) {
    emit('close');
    toggle(false);
  }
};

provideDropdownContext({
  isOpen,
  toggle,
  closeMenu,
});
</script>

<template>
  <div v-on-click-outside="closeMenu" class="relative space-y-2">
    <slot name="trigger" :is-open :toggle="() => toggle()" />
    <div
      v-if="isOpen"
      class="absolute"
      :class="openTop ? 'bottom-full mb-2' : ''"
    >
      <slot :close-menu="closeMenu" />
    </div>
  </div>
</template>
